import React from 'react';

import {Card, CardContent, CardActions, Stack, Typography, Box} from 'views/components';
import {Translate, translate, MarkdownViewer} from 'views/module';

const CostsAndIncludedCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack>
            <Typography component='div' variant='h6'>
              <Translate expression={'dashboard.sections.info.costsAndIncludedTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.costsAndIncluded')}/>
            </Typography>
          </Stack>

          <Box
            display='grid'
            gridTemplateColumns={{
              xs: '1fr',
              md: 'repeat(3, 1fr)',
            }}
            height='content-fit'
            gap={2}
          >
            <Card sx={{bgcolor: 'background.default', py: 3}}>
              <Stack>
                <Typography component='div' variant='subtitle'>
                  <Translate expression={'dashboard.sections.info.weeklyPricingTitle'}/>
                </Typography>
                <Typography component='div' variant='body2' color='text.secondary'>
                  <MarkdownViewer value={translate('dashboard.sections.info.weeklyPricing')}/>
                </Typography>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', py: 3}}>
              <Stack>
                <Typography component='div' variant='subtitle'>
                  <Translate expression={'dashboard.sections.info.monthlyPricingTitle'}/>
                </Typography>
                <Typography component='div' variant='body2' color='text.secondary'>
                  <MarkdownViewer value={translate('dashboard.sections.info.monthlyPricing')}/>
                </Typography>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', py: 3}}>
              <Stack>
                <Typography component='div' variant='subtitle'>
                  <Translate expression={'dashboard.sections.info.quarterlyPricingTitle'}/>
                </Typography>
                <Typography component='div' variant='body2' color='text.secondary'>
                  <MarkdownViewer value={translate('dashboard.sections.info.quarterlyPricing')}/>
                </Typography>
              </Stack>
            </Card>
          </Box>
        </Stack>
      </CardContent>
      <CardActions>
        <Typography component='div' variant='caption' color='text.secondary'>
          {translate('dashboard.sections.info.pricingFootnote')}
        </Typography>
      </CardActions>
    </Card>
  );
};

export default CostsAndIncludedCard;
